export const notificationConstants = {
    NOTIFICATION_LIST_REQUEST: 'NOTIFICATION_LIST_REQUEST',
    NOTIFICATION_LIST_SUCCESS: 'NOTIFICATION_LIST_SUCCESS',
    NOTIFICATION_LIST_ERROR: 'NOTIFICATION_LIST_ERROR',
    NOTIFICATION_SEARCH_REQUEST: 'NOTIFICATION_SEARCH_REQUEST',

    NOTIFICATION_UPDATE_STATUS_REQUEST: 'NOTIFICATION_UPDATE_STATUS_REQUEST',
    NOTIFICATION_UPDATE_STATUS_SUCCESS: 'NOTIFICATION_UPDATE_STATUS_SUCCESS',
    NOTIFICATION_UPDATE_STATUS_FAILURE: 'NOTIFICATION_UPDATE_STATUS_FAILURE', 

    NOTIFICATION_ADDED_REQUEST:'NOTIFICATION_ADDED_REQUEST',
    NOTIFICATION_ADDED_SUCCESS:'NOTIFICATION_ADDED_SUCCESS',
    NOTIFICATION_ADDED_FAILURE:'NOTIFICATION_ADDED_FAILURE',  


    USERS_NOTIFICATION_LIST_REQUEST: 'USERS_NOTIFICATION_LIST_REQUEST',
    USERS_NOTIFICATION_LIST_SUCCESS: 'USERS_NOTIFICATION_LIST_SUCCESS',
    USERS_NOTIFICATION_LIST_ERROR: 'USERS_NOTIFICATION_LIST_ERROR',
    USERS_NOTIFICATION_SEARCH_REQUEST: 'USERS_NOTIFICATION_SEARCH_REQUEST',

    USERS_BELL_NOTIFICATION_LIST_REQUEST: 'USERS_BELL_NOTIFICATION_LIST_REQUEST',
    USERS_BELL_NOTIFICATION_LIST_SUCCESS: 'USERS_BELL_NOTIFICATION_LIST_SUCCESS',
    USERS_BELL_NOTIFICATION_LIST_ERROR: 'USERS_BELL_NOTIFICATION_LIST_ERROR',

    SENT_NOTIFICATION_LIST_REQUEST: 'SENT_NOTIFICATION_LIST_REQUEST',
    SENT_NOTIFICATION_LIST_SUCCESS: 'SENT_NOTIFICATION_LIST_SUCCESS',
    SENT_NOTIFICATION_LIST_ERROR: 'SENT_NOTIFICATION_LIST_ERROR',
};
